import { useEffect, useRef } from 'react';

import { isWebView } from '@src/helpers';
import { sendMessageToAndroid } from '../bridge/sender';
import { generateUID } from '../bridge/handlers/share';

import { EWebViewEvents, IWebViewEvent } from '@src/bridge/types';

export const useBridgeModal = (isOpen: boolean) => {
  const prevIsOpenRef = useRef(isOpen);

  useEffect(() => {
    if (!isWebView()) return;

    if (isOpen && !prevIsOpenRef.current) {
      const uid = generateUID();
      const bridgeMessage: IWebViewEvent = {
        type: EWebViewEvents.WEB_SHEET_OPENED,
        payload: { id: uid },
      };
      sendMessageToAndroid(bridgeMessage);
    } else if (!isOpen && prevIsOpenRef.current) {
      const uid = generateUID();
      const bridgeMessage: IWebViewEvent = {
        type: EWebViewEvents.WEB_SHEET_DISMISSED,
        payload: { id: uid },
      };
      sendMessageToAndroid(bridgeMessage);
    }

    prevIsOpenRef.current = isOpen;
  }, [isOpen]);
};
